import { makeGraphQLRequest } from '../../utils/requestUtils';

export async function getRfqAndQuote(userId, rfqId, quoteId) {
  const query = `query ContractCenter(
    $userId: ID
    $rfqId: String
    $quoteId: String
  ) {
    rfqAndQuoteDetails(userId: $userId, rfqId: $rfqId, quoteId: $quoteId)  { 
      unauthorized
       quote {q_comment q_machiningReq q_qty q_toolingDesc q_toolingAvailable q_sampleAvailable deliveryDate unitPrice shipping ndaAccept status } rfq {
      companyName
      description
      phone
    poc
    solNum
    niin
    partNum
    partDesc
    quoteDueDate
    sampleDueDate
    orderDueDate
    qty
    releaseQty
    castingWt
    toolingAvailable
    sampleAvailable
    machiningReq
    toolingDesc
    prefCastProc
    secOpsReq
    reqCastSpec
    testingRqmts
    comment
    drawingNums
    nda
    status
    comment
    
    ndaList
    attachmentsList
    rfqCreateDate
    r_material
    }   
  }
    }`;

  // Variables
  const variables = { userId, rfqId, quoteId };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function editQuote(quoteObj) {
  const query = `mutation updateQuote($quote: quoteInput) { updateQuote (quote: $quote) {  status, msg  } }`;

  // Variables

  const {
    rfqId,
    quoteId,
    userId,
    unitPrice,
    qty,
    deliveryDate,
    shipping,
    toolingDesc,
    toolingAvailable,
    machiningReq,
    sampleAvailable,
    ndaAccept,
    comment,
  } = quoteObj;

  const variables = {
    quote: {
      rfqId,
      quoteId,
      userId,
      unitPrice,
      qty,
      deliveryDate,
      shipping,
      toolingDesc,
      toolingAvailable,
      machiningReq,
      sampleAvailable,
      ndaAccept,
      comment,
    },
  };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function handleQuoteSubmit(userId, rfqId, quoteId) {
  const query = `mutation handleQuoteSubmit($userId: ID, $rfqId: Int, $quoteId: Int) { handleQuoteSubmit (userId: $userId, rfqId: $rfqId, quoteId: $quoteId) { msg status  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    quoteId,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function cancelQuote(userId, rfqId, quoteId) {
  const query = `mutation cancelQuote($userId: ID, $rfqId: Int, $quoteId: Int) { cancelQuote (userId: $userId, rfqId: $rfqId, quoteId: $quoteId) { msg status msg  } }`;

  // Variables

  const variables = {
    userId,
    rfqId,
    quoteId,
  };
  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}



// WEBPACK FOOTER //
// ./src/pages/contractQuote/graphql.js